import { IAppState } from "../state/app.state";
import { createSelector, createFeatureSelector } from "@ngrx/store";

const getAppState = createFeatureSelector<IAppState>('appState');
export const isCarouselVisible = createSelector(getAppState, state => state.carouselVisible);